<template>
  <v-table class="table-data" fixed-header>
    <thead>
      <tr>
        <th v-for="item in headers" :key="item" class="text-left">
          {{ item }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in stock" :key="item._id">
        <td>{{ formatTimestamp(item.createdAt) }}</td>
        <td>{{ item.folio }}</td>
        <td>{{ item.type == 'out' ? 'Salida' : 'Entrada' }}</td>
        <td>{{ item.product_sku }}</td>
        <td>
          <span :style="{ textDecoration: item.deleted ? 'line-through' : 'none' }">
            {{ item.product_name }}
          </span>
        </td>
        <td>{{ item.quantity }}</td>
        <td>{{ item.cost }}</td>
        <td>{{ item.cost / item.quantity }}</td>
        <td>{{ item.terminal_id.name }}</td>
        <td>
          <v-icon v-if="item.note == ''" @click="editNote(item._id, item.note)" v-bind="props"
            :color="item.note !== '' ? '#FFA500' : '#5A5A5A'" style="cursor: pointer;">
            mdi-comment-outline
          </v-icon>
          <v-tooltip v-if="item.note !== ''" location="bottom">
            <template #activator="{ props }">
              <v-icon @click="editNote(item._id, item.note)" v-bind="props"
                :color="item.note !== '' ? '#FFA500' : '#5A5A5A'" style="cursor: pointer;">
                mdi-comment-outline
              </v-icon>
            </template>
            <span>{{ item.note }}</span>
          </v-tooltip>
          <v-icon style="margin-left: 10px;" v-if="!item.deleted" @click="deleteModal(item)"
            color="#DC3545">mdi-delete-outline</v-icon>
        </td>
      </tr>
    </tbody>
  </v-table>

  <add-edit-stock v-if="filterData" ref="addEditModal" @refreshList="refresh" :terminals="filterData" />
  <dialog-edit-note ref="editNote" @saveOK="refresh" />
  <dialog-delete-stock ref="deleteStock" @saveOK="refresh" />

</template>

<script>
import terminalsApi from '@/api/terminalsApi'
import dateTransform from '@/utils/dateTransform'
import AddEditStock from '../forms/AddEditStock.vue'
import DialogEditNote from '../dialogs/DialogEditNote.vue'
import DialogDeleteStock from '../dialogs/DialogDeleteStock.vue'
export default {
  name: 'CommerciaVueStockTable',
  emits: ['refreshList'],
  components: {
    AddEditStock,
    DialogEditNote,
    DialogDeleteStock
  },
  props: {
    stock: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      headers: ['Fecha', 'Folio', 'Tipo', 'Sku', 'Producto', 'Unidades', 'Importe', 'Costo unitario', 'POS', 'Acciones'],
      filterData: [{ value: 'all', label: 'Todos' }],
      business: this.$store.getters.business
    }
  },
  mounted () {
    this.getPos()
  },
  methods: {
    editModal (item) {
      this.$refs.addEditModal.edit(item)
    },
    deleteModal (item) {
      this.$refs.deleteStock.open(item._id, item.product_name)
    },
    editNote (id, note) {
      this.$refs.editNote.open(id, note)
    },
    refresh () { this.$emit('refreshList') },
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    },
    async getPos () {
      const listPos = await terminalsApi.list(this.business._id, '')
      for (const item of listPos) {
        this.filterData.push({ value: item._id, label: item.name })
      }
    }
  }
}
</script>

<style scoped>
@import '@/assets/styles/tables.css';
</style>
